import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, onActivated, ref } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: 'Thought',
  components: {
    Head: Head,
    Pagination: Pagination,
    Tabs: Tabs
  },
  setup: function setup() {
    var titleArr = ["我的思想摸排", "我的审核"];
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; //来源标示


    var source = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_source; // 表格加载

    var loading = ref(false);
    var tableloading = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_tableloading; // 第一个table的初始化

    var tableData = ref([{}]);
    var totalNum = ref(0);
    var pageIndex = ref(1); // 获取表一

    getTableOne();

    function getTableOne() {
      return _getTableOne.apply(this, arguments);
    }

    function _getTableOne() {
      _getTableOne = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getThoughtList"]({
                  pageIndex: pageIndex.value,
                  pageSize: 10,
                  statuss: '0,1,2'
                });

              case 3:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                // console.log(data, total);
                tableData.value = _toConsumableArray(data);
                totalNum.value = total;
                loading.value = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTableOne.apply(this, arguments);
    }

    function changPage(val) {
      // console.log("表1切换分页");
      pageIndex.value = val;
      getTableOne();
    } // 第二个table初始化


    var tableDataTwo = ref([{}]);
    var totalNumTwo = ref(0);
    var pageIndexTwo = ref(1);
    getTableTwo();

    function getTableTwo() {
      return _getTableTwo.apply(this, arguments);
    }

    function _getTableTwo() {
      _getTableTwo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti2, data, total;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading.value = true;
                _context2.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAuditList"]({
                  pageIndex: pageIndex.value,
                  pageSize: 10,
                  statuss: '0,1,2,3'
                });

              case 3:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                total = _yield$globalProperti2.total;
                tableDataTwo.value = _toConsumableArray(data);
                totalNumTwo.value = total;
                loading.value = false;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getTableTwo.apply(this, arguments);
    }

    function changPageTwo(val) {
      // console.log("表2切换分页");
      pageIndexTwo.value = val;
      getTableTwo();
    } // 页面激活钩子函数


    onActivated(function () {
      // 重新加载
      getTableOne();
      getTableTwo();
    }); // 查看详情

    var getDetail = function getDetail(id, state) {
      // if()
      router.push({
        name: "thoughtDetail",
        query: {
          id: id,
          state: state
        }
      });
    };

    return {
      tableloading: tableloading,
      loading: loading,
      titleArr: titleArr,
      tableData: tableData,
      totalNum: totalNum,
      pageIndex: pageIndex,
      source: source,
      changPage: changPage,
      tableDataTwo: tableDataTwo,
      totalNumTwo: totalNumTwo,
      pageIndexTwo: pageIndexTwo,
      changPageTwo: changPageTwo,
      getDetail: getDetail
    };
  }
});